import React from 'react'
import { useSelector } from 'react-redux'
import { Formik, Form } from 'formik'
import { Grid, Box, Divider, Paper } from '@mui/material'
import { styled, Typography as MIUTypography } from '@mui/material'
import { setItemsFormik } from './datasetFormik'
import { handleCreationFormik } from '../../utils/formikCreate'
import LinearInderterminate from '../LinearIndeterminate'
import ItemsContainer from '../ItemsContainer'
import TabsContainer from '../TabsContainer'
import AlertCustom from '../Alerts'
import BottonInside from '../BottonCustom/BottonInside'
import Backdrop from '../Backdrop'

const contentStyle = {
  width: '100%',
  height: '100%',
  textAlign: 'center',
}

const gridStyle = {
  mt: 0,
  width: '100%',
  ml: 0,
  textAlignLast: 'right',
  justifyContent: 'space-evenly',
  pr: 2,
}

const styleTitle = {
  py: 2,
  backgroundColor: 'var(--color-primary)',
  color: 'var(--color-white)',
}

const Typography = styled(MIUTypography)(props => ({
  fontFamily: 'var(--font-family)',
  fontStyle: 'normal',
  fontSize: '1em',
  fontWeight: 600,
  color: '#1B1C37',
}))

const TreeRegistrationForm = () => {
  const alertRef = React.useRef()
  const backdropRef = React.useRef()
  const [formik, setFormik] = React.useState(null)
  const [isStored, setIsStored] = React.useState(null)

  const TOKEN = `Bearer ${window.localStorage.getItem('arbolQR_Token')}`
  const HEIGHT_PAPER = 'calc(100vh - 100px)'

  const { temporal, enableSaveButton: groupFieldAutocomplete } = useSelector(
    state => state.treeFeatures
  )
  const lnglat = useSelector(state => state.mapState.marker.lnglat)

  React.useEffect(() => {
    setItemsFormik(null).then(variables => {
      setFormik(variables)
    })
    return () => setFormik(null)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  React.useEffect(() => {
    if (!Boolean(isStored)) return
    setTimeout(() => {
      alertRef?.current?.openAlert(true)
    }, 1000)
  }, [isStored])

  React.useEffect(() => {
    if (!Boolean(isStored?.stored)) return
    backdropRef?.current?.openAlert(true)
  }, [isStored])

  if (!Boolean(formik)) return <LinearInderterminate />

  return (
    <Box sx={contentStyle}>
      <Formik
        initialValues={{ ...formik?.INITIAL_FORMIK_STATE }}
        validationSchema={formik?.FORM_VALIDATION}
        onSubmit={async values => {
          const itsStored = await handleCreationFormik(
            values,
            temporal,
            formik?.ITEMS_INCONVENIENCE_FORMIK,
            groupFieldAutocomplete,
            TOKEN,
            lnglat
          )
          setIsStored(itsStored)
        }}>
        <Form>
          <Paper style={{ height: HEIGHT_PAPER, overflow: 'auto', borderRadius: 0 }}>
            <Typography sx={styleTitle}>INFORMACIÓN GENERAL DEL ÁRBOL</Typography>
            <Divider />

            <Grid container spacing={2} sx={{ ...gridStyle }}>
              {formik?.ITEMS_GENERAL_FORMIK.map((o, i) => (
                <ItemsContainer key={`formik-${i}`} {...o} editable={true} />
              ))}
            </Grid>

            <Divider sx={{ pt: 2 }} />
            <Typography sx={styleTitle}>UBICACIÓN Y MEDICIONES FENOTÍPICAS</Typography>
            <Divider />

            <Grid container spacing={2} sx={{ ...gridStyle }}>
              {formik?.ITEMS_ATTRIBUTES_FORMIK.map((o, i) => (
                <ItemsContainer key={`formik-inconv-${i}`} {...o} editable={true} />
              ))}
            </Grid>

            <Divider sx={{ pt: 2 }} />
            <Typography sx={styleTitle}>
              ESTADO FITOSANITARIO, PROBLEMAS, <br /> RIESGOS, Y ACCIONES RECOMENDADAS
            </Typography>
            <Divider />

            <TabsContainer itemsfk={formik?.ITEMS_INCONVENIENCE_FORMIK} editable={true} />
          </Paper>
          <BottonInside enableButton={Boolean(lnglat?.length)} />
        </Form>
      </Formik>
      <AlertCustom
        ref={alertRef}
        severity={isStored?.stored !== true ? 'warning' : 'success'}>
        {isStored?.stored !== true ? isStored?.message : 'Guardado exitosamente.'}
      </AlertCustom>
      <Backdrop ref={backdropRef} treeId={isStored?.treeId} />
    </Box>
  )
}

export default React.memo(TreeRegistrationForm)
